<template>
    <div class="MAM_stockList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="stockForm" class="demo-form-inline">
                <!-- <el-form-item>
                    <el-select size v-model="stockForm.type" clearable placeholder="请选择库存所属">
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="平台库存" value="1" v-if="level == 0"></el-option>
                        <el-option label="我的库存" value="1" v-if="level == 1"></el-option>
                        <el-option label="代理库存" value="2"></el-option>
                    </el-select>
                </el-form-item> -->
                <!--<el-form-item v-if="stockForm.type == 2">-->
                <el-form-item>
                    <el-input size clearable v-model="stockForm.real_name" placeholder="请输入代理姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="stockForm.nick_name" placeholder="请输入代理商昵称"></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0">
                    <el-input size clearable v-model="stockForm.level" placeholder="代理商等级"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input size clearable v-model="stockForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(stockForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 20px;" v-if="level == 0">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addStock">导入库存</el-button>
                <el-button size="small" type="primary" icon="el-icon-delete" @click="delStock">删除库存</el-button>
            </div>
            <el-table
                :data="stockTable.list"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 代理昵称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nickname"
                    label="所属代理昵称"
                    min-width="120"
                ></el-table-column>
                <!-- 所属代理姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="所属代理姓名"
                    min-width="120"
                ></el-table-column>
                   <el-table-column
                    v-if="level == 0"
                   header-align="center"
                   align="center"
                   prop="level"
                   label="代理商等级"
                   min-width="120"
               ></el-table-column>
                <!-- 代理电话 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="所属代理电话"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                            <p>{{ scope.row.phone }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 代理电话 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    label="所属代理编号"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="inventory_two"
				    label="2.0政策库存总量"
				    min-width="120"
				>
				</el-table-column>
				
				<el-table-column header-align="center" align="center" prop="exchange_total_num" label="可兑换数"></el-table-column>
				<el-table-column header-align="center" align="center" prop="unexchange_num" label="未兑换数"></el-table-column>
				<el-table-column header-align="center" align="center" prop="exchange_num" label="已兑换数"></el-table-column>
				<!-- <el-table-column header-align="center" align="center" fixed="right" label="操作"  >
					<template slot-scope="scope">
						<div  v-if="level == 0 || level == 1">
							<el-button v-if="scope.row.level == 2 && scope.row.is_loop_back == 1" @click="handleInTotal(scope.row)" type="text" size="small">去兑换</el-button>
							<el-button v-else  type="text" size="small">-</el-button>
						</div>
						<div  v-if="level > 1">
							<el-button v-if="scope.row.is_loop_back == 1" @click="handleInTotal(scope.row)" type="text" size="small">去兑换</el-button>
							<el-button v-else type="text" size="small">-</el-button>
						</div>
					</template>
				</el-table-column> -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="in_total_num"
                    label="总接收划拨数"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleInTotal(scope.row)"
                            type="text"
                            size="small"
                        >{{scope.row.user_id == 0 ? scope.row.admin_in_num : scope.row.in_total_num}}</el-button>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="return_total_num"
                    label="总退回至上级数"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleReturnTotal(scope.row)"
                            type="text"
                            size="small"
                        >{{scope.row.return_total_num}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="other_return"
                        label="总接收退回数"
                        min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                                @click="handleReturn(scope.row)"
                                type="text"
                                size="small"
                        >{{scope.row.other_return}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="my_stock"
                    label="当前库存总台数"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleTotal(scope.row)"
                            type="text"
                            size="small"
                        >{{scope.row.my_stock}}</el-button>
                    </template>
                </el-table-column> -->
                <!-- 划拨中台数 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="my_transfer"
                    label="已划拨下级台数"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleTransfer(scope.row)"
                            type="text"
                            size="small"
                        >{{scope.row.my_transfer}}</el-button>
                    </template>
                </el-table-column> -->
                <!-- 退回中台数 -->
<!--                <el-table-column-->
<!--                    header-align="center"-->
<!--                    align="center"-->
<!--                    prop="my_return"-->
<!--                    label="已退回上级台数"-->
<!--                    min-width="120"-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button-->
<!--                            @click="handleReturn(scope.row)"-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                        >{{scope.row.my_in_return}}</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <!-- 绑定中 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="my_net"
                    label="已绑定台数"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleNet(scope.row)"
                            type="text"
                            size="small"
                        >{{scope.row.my_net}}</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <stock-tools
            v-if="toolsIsShow"
            :toolsIsShow="toolsIsShow"
            :isAdd="isAdd"
            @toolsClose="toolsClose"
        ></stock-tools>
        <uts-info v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></uts-info>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
import stockTools from './MAM_stockTools';
// import stockInfo from './MAM_stockInfo';
import UtsInfo from './UtsInfo';
export default {
    name: "MAM_stockList",
    data() {
        return {
            level:sessionStorage.getItem('level'),
            isAdd: false, //添加库存、删除库存
            isTotal: false, //是否为库存总台数
            toolsIsShow: false, //导入、删除库存
            infoIsShow: false, //详情
            detail: {
                isShow: false,
                type: null, //1.当前库存 2.划拨中 3.退回中 4.绑定中
                info: null
            },
            stockForm: {
                type: '',
                user_name: '',
                terminal_sn: ''
            },
            stockTable: {
                list: [],
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 100  //总数
            },
            loading: true
        }
    },
    mounted() {
        //初始化
        this.getData({
            page: this.page.currentPage,
            limit: this.page.pageSize
        })
    },
    components: {
        paginations,
        stockTools,
        UtsInfo
    },
    methods: {
        onSearch(stockForm) {
            this.page.currentPage = 1;
            stockForm.page = this.page.currentPage;
            stockForm.limit = this.page.pageSize;
            // 表单提交
            this.getData(stockForm);
        },
        handleInTotal(row) { //历史总入库
            // this.detail.isShow = true;
            // this.detail.type = 5;
            // this.detail.info = row;
			if(row.is_loop_back == 0){
				this.$message.error('代理商未开通循环返禁止兑换');
			}else{
				this.$router.push({
					path: "/UtsInfo",
					query: {
						data: row,
					}
				})
			}
        },
        handleReturnTotal(row) { //历史总退回
            this.detail.isShow = true;
            this.detail.type = 6;
            this.detail.info = row;
        },
        handleTotal(row) { //剩余台数
            this.detail.isShow = true;
            this.detail.type = 1;
            this.detail.info = row;
        },
        handleTransfer(row) { //划拨中台数
            this.detail.isShow = true;
            this.detail.type = 2;
            this.detail.info = row;
        },
        handleReturn(row) { //退回中台数
            this.detail.isShow = true;
            this.detail.type = 3;
            this.detail.info = row;
        },
        handleNet(row) {
            this.detail.isShow = true;
            this.detail.type = 4;
            this.detail.info = row;
        },
        infoClose() { //关闭详情
            this.detail.isShow = false;
        },
        addStock() {
            this.isAdd = true
            this.toolsIsShow = true;
        },
        delStock() {
            this.toolsIsShow = true;
        },
        toolsClose(ref) { //关闭导入、删除库存
            this.isAdd = false;
            this.toolsIsShow = false;
            if (ref) { //重载表格
                this.getData({
                    page: this.page.currentPage,
                    limit: this.page.pageSize
                })
            }
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.loading = true;
            this.page.currentPage = page;
            this.stockForm.page = page;
            this.stockForm.limit = this.page.pageSize;
            this.getData(this.stockForm)
        },
        getPageSize(limit) {
            this.page.currentPage = 1;
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.stockForm.page = this.page.currentPage;
            this.stockForm.limit = limit;
            this.getData(this.stockForm);
        },
        getData(params) {
            this.$api.post("terminal/getTerminalList", params, res => {
                let data = res.data;
                this.page.total = data.total; //总数
                this.stockTable.list = data.data;
                //渲染结束后取消加载
                this.loading = false;
            });
        }
    },
    watch: {
        'stockForm.type'(newVal) {
            if (newVal != 2) {
                this.stockForm.user_name = '';
            }
        }
    }
};
</script>

<style lang="scss" scope>
.MAM_stockList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>
